import { TestimonialsList } from "../../types/HomeDemo";

export const TestimonialsData: TestimonialsList = {
  CarDemo1: [
    {
      name: "Sweden J.",
      location: "Ontario",
      image: "car/testimonial/1.jpg",
      testimonial: "I had an amazing experience buying my SUV from fuso. The staff was helpful and knowing, making the process smooth and satisfying. I'm overjoyed.",
    },
    {
      name: "Sarah J.",
      location: "Toronto",
      image: "car/testimonial/2.jpg",
      testimonial: "The service at fuso was exceptional from start to finish. They kept me informed and satisfied throughout. Highly recommend for anyone buying a new car!",
    },
    {
      name: "David K.",
      location: "London",
      image: "car/testimonial/3.jpg",
      testimonial: "Excellent service at fuso. The team went above and beyond to secure a great deal on my new car. I'm very satisfied and will return.",
    },
    {
      name: "Sophia L.",
      location: "Vaughan",
      image: "car/testimonial/4.jpg",
      testimonial: "I was impressed by the wide vehicle selection and the team's expertise. They made finding and buying my car smooth and enjoyable. Thank you, fuso!",
    },
    {
      name: "James T.",
      location: "Hamilton",
      image: "car/testimonial/5.jpg",
      testimonial: "The service at fuso was top-notch from start to finish. I appreciated the transparency and honesty. I love my new sedan and will return for future buy.",
    },
    {
      name: "Emily S.",
      location: "Windsor",
      image: "car/testimonial/6.jpg",
      testimonial: "I had an outstanding experience with [Your Company Name]. The patient and knowledgeable team ensured I was satisfied with my new car. Thank you!",
    },
  ],
  CarDemo2: [
    {
      name: "-Sarah M.",
      position: "Manager",
      text: "I am thoroughly impressed with the performance and reliability of my new car. The smooth ride and advanced features make every journey a pleasure.",
      rating: 4.5,
    },
    {
      name: "-Jane D.",
      position: "Manager",
      text: "I recently purchased my dream car, and the entire experience was seamless. The customer service was top-notch, and I couldn't be happier with my new ride!",
      rating: 4.5,
    },
    {
      name: "-Jane S.",
      position: "Manager",
      text: "This is my third car from this dealership, and each time the process has been smooth and efficient. I highly recommend them to anyone looking for a reliable vehicle.",
      rating: 4.5,
    },
    {
      name: "-Olivia D.",
      position: "Manager",
      text: "Excellent experience! The car was in perfect condition, and the team provided top-notch service from start to finish. Will definitely be coming back!",
      rating: 4.5,
    },
    {
      name: "-Emily D.",
      position: "Manager",
      text: "The test drive was a breeze, and the team was very accommodating with my busy schedule. I’m thrilled with my new car and would definitely return for future purchases.",
      rating: 4.5,
    },
    {
      name: "-Jessica T.",
      position: "Manager",
      text: "Amazing experience! The sales team was patient and listened to all my concerns. I ended up with a car I love and felt well taken care of throughout the entire process.",
      rating: 4.5,
    },
    {
      name: "-Megan W.",
      position: "Manager",
      text: "I couldn’t have asked for a better experience. The staff was helpful and ensured I understood every aspect of my purchase. Loving my new car and the smooth process!",
      rating: 4.5,
    },
  ],
  JobDemo2: [
    {
      name: "Sarah M.",
      role: "UI/UX Designer",
      text: "I found my dream job within weeks! The personalized recommendations and comprehensive resources made all the difference in my job search journey.",
    },
    {
      name: "Sarah M.",
      role: "Marketing Specialist",
      text: "I landed my ideal role in weeks thanks to personalized job recommendations, extensive resources, and tailored support.",
    },
    {
      name: "James P.",
      role: "Graphic Designer",
      text: "Tailored tools and job suggestions were game-changers in my search, helping me find my dream job quickly and efficiently.",
    },
    {
      name: "Olivia M.",
      role: "Human Resources Manager",
      text: "Rich resources and tailored job suggestions were useful to me in this search. I'm happy to have fast found a role that matches my goals and skill set.",
    },
    {
      name: "Emma W.",
      role: "Data Analyst",
      text: "Targeted job recommendations and resources helped me quickly secure my ideal position with invaluable support.",
    },
    {
      name: "Lucas G.",
      role: "UI/UX Designer",
      text: "Customized recommendations and resources helped me find a fantastic opportunity within weeks. I’m thrilled!",
    },
  ],
  PropertyDemo1: [
    {
      name: "Hannan Odeth",
      position: "Hannan Odeth",
      content: "“I recently purchased a home through this Realty and I had an amazing experience. My agent, John, was incredibly professional and knowledgeable about the market. His attention to detail was impressive.”",
    },
    {
      name: "Esther Howard",
      position: "Esther Howard",
      content: "“With the most recent sale of my house, this was vital, and I couldn't be happier with the outcome! During the process, they offered dependable counsel because they were aware about the current industry trends.”",
    },
    {
      name: "Jenny Wilson",
      position: "Jenny Wilson",
      content: "“The process of renting the apartment was very smooth and straightforward. The leasing agent, Sarah, was very professional, responsive, and helpful in answering all my questions and concerns.”",
    },
  ],
  PropertyDemo2: [
    { content: "We couldn't have asked for a better experience with Premier Estates. From the moment we set foot in Serenity Cove, we knew it was the perfect place for our family.", title: "-The Johnson Family" },
    { content: "This fantastic staff helped us find our ideal house! Their advice proved to be useful, and the procedure went well. What a difference their experience made.", title: "-The Grimsby Family" },
    { content: "A achievement of a dream! The house is incredible and the neighborhood is peaceful and secure. We made the most important choice of our lives when we moved here.", title: "-The Ashford Family" },
  ],
};
